import Breadcrumb from '@/components/ui/Breadcrumb';

const MATCH_FLOW = [
  { a:'入场', b:'15s (方案2) / 30s (方案3 团队)', c:'双方放车入起始格，裁判确认' },
  { a:'第一局', b:'3分钟', c:'正常对抗' },
  { a:'局间', b:'1分钟', c:'快速调整车辆、更换受损零件' },
  { a:'第二局', b:'3分钟', c:'交换起始角重新开战' },
  { a:'决胜局', b:'2分钟', c:'1:1 后突然死亡——先翻车/出界/无法移动者直接输' },
];

const WIN_CONDITIONS = [
  { p:'1', c:'翻车 KO', d:'侧翻触地超过 3 秒，裁判喊 KO，直接判负', color:'#FF3B3B' },
  { p:'2', c:'出界', d:'整车离开场地边界（四角无围栏处），直接判负', color:'#FF6D00' },
  { p:'3', c:'TKO', d:'车辆无法移动超过 10 秒，裁判喊 TKO 判负', color:'#FFB800' },
  { p:'4', c:'缩圈决胜', d:'3 分钟结束双方均在界内，按出界次数判定；方案3触发缩圈', color:'#00C2FF' },
];

export default function ArenaRulesPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 pt-8 pb-16">
      <Breadcrumb items={[{ label:'首页', href:'/' }, { label:'赛事', href:'/arena' }, { label:'完整规则' }]} />

      <h1 className="text-2xl font-extrabold text-text-primary mb-2">对抗赛完整规则</h1>
      <p className="text-text-secondary text-sm mb-10">方案 2/3 通用规则，含个人赛与团队赛全部细则</p>

      <section className="mb-10">
        <h2 className="text-lg font-extrabold text-text-primary mb-4">赛制与流程</h2>
        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-5 space-y-3 text-sm">
          {MATCH_FLOW.map((r) => (
            <div key={r.a} className="flex items-start gap-4 pb-3 border-b border-border-dark/50 last:border-0 last:pb-0">
              <span className="text-text-disabled w-20 shrink-0 text-xs">{r.a}</span>
              <span className="text-arena-gold font-mono text-xs w-40 shrink-0">{r.b}</span>
              <span className="text-text-secondary text-xs">{r.c}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-lg font-extrabold text-text-primary mb-4">胜负判定（单局）</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {WIN_CONDITIONS.map((r) => (
            <div key={r.p} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-4 flex items-start gap-3">
              <span className="text-lg font-extrabold font-mono shrink-0" style={{color:r.color}}>{r.p}</span>
              <div><p className="text-sm font-extrabold text-text-primary">{r.c}</p><p className="text-xs text-text-secondary mt-1">{r.d}</p></div>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-lg font-extrabold text-text-primary mb-4">同分决胜：离中心点更近者胜（方案2/3）</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div className="bg-panel-dark/40 border border-arena-gold/30 rounded-card-lg p-5">
            <h3 className="text-sm font-semibold text-arena-gold mb-3">场地标记</h3>
            <p className="text-xs text-text-secondary leading-relaxed mb-3">在 3m x 3m 场地地面绘制同心圆（粉笔/胶带/印刷标记均可），圆心为场地几何中心。</p>
            <div className="space-y-1.5 text-xs">
              {[['内圈 (3分)','直径 80cm'],['中圈 (2分)','直径 1.6m'],['外圈 (1分)','直径 2.4m']].map(([k,v]) => (<div key={k} className="flex justify-between py-1"><span className="text-text-disabled">{k}</span><span className="text-text-secondary">{v}</span></div>))}
            </div>
          </div>
          <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg p-5">
            <h3 className="text-sm font-semibold text-text-primary mb-3">判定规则</h3>
            <div className="space-y-2 text-xs">
              {[
                ['一方在更内圈','该方胜'],
                ['双方同圈','车头朝向中心点更近者胜'],
                ['同圈 + 同朝向','强制重启——退回起始线间距 30cm'],
              ].map(([k,v]) => (<div key={k} className="flex justify-between py-1.5 border-b border-border-dark/30"><span className="text-text-secondary">{k}</span><span className="text-arena-gold font-medium">{v}</span></div>))}
              <p className="text-[11px] text-text-disabled mt-2 pt-2 border-t border-border-dark">裁判喊停后双方松遥控器，目视判断前轮轴心位置。车头方向以楔形壳体指向为准（前低后高）。</p>
            </div>
          </div>
        </div>
        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg p-4 text-xs text-text-secondary">
          <p>零电子设备依赖。离中心近=进攻主动，离中心远=消极避战。物理距离本身就是天然的"消极惩罚"——绕圈跑的车 3 分钟结束时必然在边缘，主动进攻的车自然更靠近中心。</p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-lg font-extrabold text-text-primary mb-4">爆发机制（方案2/3）</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-panel-dark/40 border border-arena-gold/30 rounded-card-lg mecha-card mecha-bolt p-5">
            <h3 className="text-sm font-semibold text-arena-gold mb-3">参数</h3>
            <div className="space-y-1.5 text-xs">
              {[['常态 PWM 上限','85%（固件锁死）'],['爆发 PWM','100%'],['每局次数','3 次'],['单次时长','8 秒'],['触发方式','选手编程决定']].map(([k,v]) => (<div key={k} className="flex justify-between py-1"><span className="text-text-disabled">{k}</span><span className="text-text-secondary">{v}</span></div>))}
            </div>
          </div>
          <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-5 md:col-span-2">
            <h3 className="text-sm font-semibold text-text-primary mb-3">设计意图</h3>
            <p className="text-xs text-text-secondary leading-relaxed mb-3">不依赖任何外部裁判设备，完全由主板固件控制。常态 PWM 85% 限制保证电机安全，爆发时 100% 输出提供有限的战术爆发力。3 次 x 8 秒 = 24 秒总爆发，占 180 秒单局的 13%。</p>
            <div className="grid grid-cols-2 gap-2 text-xs">
              {[
                ['开局抢位','快速占据有利攻击角度'],
                ['追击对手','缩短距离，迫使接触'],
                ['顶牛僵持','突然加大推力推出对手'],
                ['被追击逃脱','拉开距离，重新调整'],
                ['最后30秒','孤注一掷，三次连发翻盘'],
              ].map(([k,v]) => (<div key={k} className="flex justify-between py-1 border-b border-border-dark/40"><span className="text-arena-gold/80">{k}</span><span className="text-text-secondary text-right">{v}</span></div>))}
            </div>
          </div>
        </div>
        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-5 text-xs text-text-secondary space-y-2">
          <p><span className="text-text-disabled">固件实现：</span>TB6612FNG 通过 PWM 占空比控制电机。爆发不涉及任何硬件改动，固件中加一段逻辑——常态 85%，收到指令提到 100%，内部计时 8 秒自动回落，内部计数 3 次用完不再响应。选手无法修改 PWM 上限、次数和时长，这三个参数写在 ROM 保护区。</p>
          <p><span className="text-text-disabled">原理：</span>PWM 从 85% 到 100%，空载时表现为速度提升，顶牛时表现为扭力提升。130 电机额定电压 3V-6V，18650 满电 4.2V，100% PWM 时电机两端约 4.0V，远未超出额定范围。齿轮减速组本身限制电机负载，过载时齿轮先坏保护电机。</p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-lg font-extrabold text-text-primary mb-4">团队赛 2v2 特殊规则</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs">
          {[
            '队友之间碰撞不设任何判罚——物理该怎样就怎样',
            '一车出局后留在场内做静止障碍物，对方不得故意撞击',
            '可以推队友翻倒的车帮它翻回来，也可以推对手翻倒的车',
            '故意撞对手正在救援队友的车——允许，这就是战术',
            '第二局交换起始角',
            '可报 2-3 人（2正选+1替补），局间可换人也可换车',
            '团队赛为单败淘汰，不在赛季积分体系内',
            '同一选手可同时报名单人赛和团队赛',
          ].map((r, i) => (
            <div key={i} className="flex items-start gap-2 bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-3">
              <span className="w-1 h-1 rounded-full bg-arena-blue mt-1.5 shrink-0" />
              <span className="text-text-secondary">{r}</span>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-lg font-extrabold text-text-primary mb-4">判罚与武器合规</h2>
        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-5 text-xs text-text-secondary space-y-2">
          <p><span className="text-text-disabled">黄牌：</span>故意连续追撞、窄桥段故意堵路、轻微违反体育精神。累计两张黄牌=红牌取消资格。</p>
          <p><span className="text-text-disabled">红牌：</span>故意损坏对手车辆、通信干扰对手、严重违反体育精神。当场取消资格。</p>
          <p><span className="text-text-disabled">争议解决（方案2）：</span>教师/裁判最终裁定，不服可重赛一局（每场限一次）。</p>
          <p><span className="text-text-disabled">车辆损坏：</span>每队可报备一辆备用车（同规格），局间可直接换车。每场每队可申请一次维修暂停（3 分钟），仅更换零件不换整车。</p>
          <p><span className="text-text-disabled">不设消极比赛判罚：</span>同分决胜机制用物理距离自动解决僵持，无需强制碰撞。</p>
          <p className="pt-2 border-t border-border-dark"><span className="text-text-disabled">绝对禁止（全组别）：</span>高速旋转武器、尖锐穿刺物、喷射液体/粉末/火焰、电磁干扰装置、电击/高热装置。</p>
        </div>
      </section>
    </div>
  );
}
